export enum APIKeys {
  FILES = 'files',
  POLLS = 'polls',
  ROLES = 'roles',
  RISKS = 'risks',
  ASSETS = 'assets',
  SOURCES = 'sources',
  FEATURES = 'features',
  SETTINGS = 'settings',
  CLUSTERS = 'clusters',
  WORKFLOWS = 'workflows',
  INVENTORY = 'inventory',
  AUDIT_LOGS = 'audit_logs',
  CATEGORIES = 'categories',
  SAAS_GRAPH = 'saas_graph',
  FORTICLOUD = 'forticloud',
  RISK_ITEMS = 'risk_items',
  REDIS_KEYS = 'redis_keys',
  ATTACK_PATH = 'attack_path',
  PERMISSIONS = 'permissions',
  FILE_PREVIEW = 'file_preview',
  FILTER_VIEWS = 'filter_views',
  SYSTEM_USERS = 'system_users',
  APPLICATIONS = 'applications',
  INTEGRATIONS = 'integrations',
  NOTIFY_USERS = 'notify_users',
  RISK_HISTORY = 'risk_history',
  SENSITIVITIES = 'sensitivities',
  FILES_OPTIONS = 'files_options',
  NOTIFICATIONS = 'notifications',
  FILES_FOLDERS = 'files_folders',
  RELEASE_NOTES = 'release_notes',
  FILES_MESSAGES = 'files_messages',
  FILES_CREATORS = 'files_creators',
  RISKS_BASELINE = 'risks_baseline',
  FILE_DOWNLOADS = 'file_downloads',
  SHARED_ACCOUNTS = 'shared_accounts',
  REDIS_KEY_VALUE = 'redis_key_value',
  WORKERS_OPTIONS = 'workers_options',
  SYSTEM_SETTINGS = 'system_settings',
  CATEGORIES_TAGS = 'categories_tags',
  DOMAINS_OPTIONS = 'domains_options',
  WORKFLOW_FIELDS = 'workflow_fields',
  STATUS_SETTINGS = 'status_settings',
  RISK_ASSESSMENT = 'risk_assessment',
  FILES_CATEGORIES = 'files_categories',
  DASHBOARD_LAYOUT = 'dashboard_layout',
  FILE_PERMISSIONS = 'file_permissions',
  APPLICATION_RISKS = 'application_risks',
  FILE_MESSAGE_BODY = 'file_message_body',
  FILES_PII_OPTIONS = 'files_pii_options',
  APPLICATION_USERS = 'application_users',
  FILE_SHARING_DATA = 'file_sharing_data',
  RISK_HISTORY_ITEMS = 'risk_history_items',
  SOURCES_BY_DEVICES = 'sources_by_devices',
  FORTICLOUD_ACCOUNTS = 'forticloud_accounts',
  DATA_PATTERNS_TABLE = 'data_patterns_table',
  TICKETING_WORKFLOWS = 'ticketing_workflows',
  DASHBOARD_NEW_RISKS = 'dashboard_new_risks',
  POLICIES_CATEGORIES = 'policies_categories',
  ASSIGN_EMAIL_OPTIONS = 'assign_email_options',
  FILE_DOWNLOADS_DATES = 'file_downloads_dates',
  AUTOCOMPLETE_OPTIONS = 'autocomplete_options',
  RELEASE_NOTE_PREVIEW = 'release_note_preview',
  SHARED_ACCOUNTS_TABLE = 'shared_accounts_table',
  APPLICATION_USER_INFO = 'application_user_info',
  API_INTERGRATIONS_KEYS = 'api_integrations_keys',
  GLOBAL_WORKERS_OPTIONS = 'global_workers_options',
  FILES_MESSAGES_OPTIONS = 'files_messages_options',
  BUSINESS_JUSTIFICATION = 'business_justification',
  SUPPORTED_APPLICATIONS = 'supported_applications',
  BROWSER_SESSION_TRACES = 'browser_session_traces',
  DASHBOARD_STATS_METRICS = 'dashboard_stats_metrics',
  NOTIFICATIONS_TEMPLATES = 'notifications_templates',
  THIRD_PARTY_APPLICATION = 'third_party_application',
  APPLICATIONS_USERS_INFO = 'applications_users_info',
  THIRD_PARTY_APPLICATIONS = 'third_party_applications',
  FILE_MESSAGE_ATTACHMENTS = 'file_message_attachments',
  SLACK_INTEGRATIONS_USERS = 'slack_integrations_users',
  TEAMS_INTEGRATIONS_USERS = 'teams_integrations_users',
  DASHBOARD_RISK_OVER_TIME = 'dashboard_risk_over_time',
  DASHBOARD_NEW_IDENTITIES = 'dashboard_new_identities',
  BROWSER_SESSION_RECORDING = 'browser_session_recording',
  DASHBOARD_NEW_APPLICATIONS = 'dashboard_new_applications',
  INTEGRATIONS_TICKET_FIELDS = 'integrations_ticket_fields',
  APPLICATIONS_FORMS_SCHEMAS = 'applications_forms_schemas',
  POLICIES_IDS_BY_ASSETS_IDS = 'policies_ids_by_assets_ids',
  FORTICLOUD_ACCOUNT_SELECTION = 'forticloud_account_selection',
  THIRD_PARTY_APPLICATION_USER = 'third_party_application_user',
  RISK_ASSESSMENT_QUESTIONNAIRE = 'risk-assessment-questionnaire',
  APPLICATIONS_USERS_ACTIVITIES = 'applications_users_activities',
  THIRD_PARTY_APPLICATIONS_USERS = 'third_party_applications_users',
  THIRD_PARTY_APPLICATIONS_TABLE = 'third_party_applications_table',
  DASHBOARD_NEW_THIRD_PARTY_APPS = 'dashboard_new_third_party_apps',
  RISKS_BASELINE_FRAMEWORK_STATS = 'risks_baseline_framework_stats',
  RISKS_BASELINE_STANDARDS_STATS = 'risks_baseline_standards_stats',
  APPLICATIONS_SHADOW_SAAS_USERS = 'applications_shadow_saas_users',
  THIRD_PARTY_APPLICATIONS_STATS = 'third_party_applications_stats',
  DASHBOARD_RISKS_TYPES_OVER_TIME = 'dashboard_risks_types_over_time',
  APPLICATIONS_USERS_INFO_HISTORY = 'applications_users_info_history',
  APPLICATIONS_USERS_INFO_SUMMARY = 'applications_users_info_summary',
  LARGE_EXPORTS_RECIPIENTS_OPTIONS = 'large_exports_recipients_options',
  THIRD_PARTY_APPLICATION_COMMENTS = 'third_party_application_comments',
  INTEGRATION_CONFIGURATION_FIELDS = 'integration_configuration_fields',
  THIRD_PARTY_APPLICATIONS_OPTIONS = 'third_party_applications_options',
  SHADOW_SAAS_DOMAINS_INTERACTIONS = 'shadow_saas_domains_interactions',
  RISKS_BASELINE_APPLICATIONS_TYPE = 'risks_baseline_applications_type',
  DASHBOARD_RISKS_PRIORITY_OVER_TIME = 'dashboard_risks_priority_over_time',
  SHADOW_SAAS_BUSINESS_JUSTIFICATION = 'shadow_saas_business_justification',
  EXTERNAL_TOKEN_APPLICATION_DETAILS = 'external_token_application_details',
  APPLICATIONS_USERS_POTENTIAL_SAVING = 'applications_users_potential_saving',
  THIRD_PARTY_APPLICATIONS_USERS_TABLE = 'third_party_applications_users_table',
  APPLICATION_CONNECTION_STATUS_OPTIONS = 'application_connection_status_options',
  THIRD_PARTY_APPLICATIONS_USERS_OPTIONS = 'third_party_applications_users_options',
  APPLICATIONS_APPLICATION_DATA_ARTIFACT = 'applications_application_data_artifact',
  APPLICATIONS_USERS_ACTIVITIES_LOCATIONS = 'applications_users_activities_locations',
  APPLICATIONS_SHADOW_SAAS_USERS_POLLS_COUNT = 'applications_shadow_saas_users_polls_count',
  APPLICATIONS_USERS_ACTIVITIES_OVERTIME_STATS = 'applications_users_activities_overtime_stats',
  APPLICATIONS_USERS_ACTIVITIES_COUNT_BY_USERS = 'applications_users_activities_count_by_users',
  APPLICATIONS_SHADOW_SAAS_USERS_OVERTIME_STATS = 'applications_shadow_saas_users_overtime_stats',
  THIRD_PARTY_APPLICATIONS_USERS_IS_POLL_EXISTS = 'third_party_applications_users_is_poll_exists',
  APPLICATIONS_SHADOW_SAAS_USERS_ACTIVITY_STATS = 'applications_shadow_saas_users_activity_stats',
  THIRD_PARTY_APPLICATIONS_USERS_IS_LAST_INTERACTION_EXISTS = 'third_party_applications_users_is_last_interaction_exists',
  SHADOW_SAAS_APPLICATIONS_USERS_IS_LAST_INTERACTION_EXISTS = 'shadow_saas_applications_users_is_last_interaction_exists',
}
